import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { BudgetFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// APP
import DashboardComponent from '../../../components/DashboardComponent';
import BudgetListComponent from '../../../components/Budgets/BudgetListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function BudgetRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new BudgetFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Presupuestos</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={BudgetListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}
